import React from 'react';
import PropTypes from 'prop-types';
import ReactTextAreaWrapper from '../Wrappers/ReactTextAreaWrapper';
import ReactFileReader from 'react-file-reader';
import classNames from 'classnames';
import moment from 'moment';
import { truncate } from 'lodash';
import CustomDatePicker from './CustomDatePicker';
import TimePicker from './TimePicker';

import 'react-datepicker/dist/react-datepicker.css';

const RadioButton = ({ active, text, onClickFn }) => (
  <button
    className="new-post-radio-button"
    onClick={onClickFn}
    aria-pressed={active}
  >
    <i
      className={classNames('fa mr-2 icon', {
        'fa-circle-thin': !active,
        'fa-circle': active
      })}
      aria-hidden="true"
    />
    {text}
  </button>
);

const DayToggle = ({ active, text, onClickFn }) => (
  <button
    className={classNames('new-post-day-toggle px-0 py-2', {})}
    onClick={onClickFn}
    key={text}
    aria-pressed={active}
  >
    {text}
  </button>
);

export default class SpecialPost extends React.Component {
  state = {
    allDay: true,
    repeating: false
  };

  addTime = () => {
    const { field } = this.props;

    field('hours').validations.val.push({
      startTime: '00:00',
      endTime: '00:00'
    });

    this.props.onChange(field('hours'), field('hours').validations.val);
  };

  removeTime = () => {
    const { field } = this.props;

    field('hours').validations.val.pop();

    this.props.onChange(field('hours'), field('hours').validations.val);
  };

  handleEndChange = date => {
    this.props.onChange(this.props.field('end'), date);
  };

  handleStartChange = date => {
    this.props.onChange(this.props.field('start'), date);

    if (!this.state.repeating) {
      this.props.onChange(this.props.field('end'), date);
    }

    this.props.field('days').validations.val = moment.weekdays().map(w => ({
      text: w,
      active: date.format('dddd') === w ? true : false
    }));
  };

  handleRepeatFrequencyClick = v => {
    this.setState({ repeatFrequency: v });
  };

  setDefaultInputs = () => {
    const { field } = this.props;

    const valid = label => field(label) && field(label).validations.val === '';

    if (valid('start')) field('start').validations.val = moment();
    if (valid('end')) field('end').validations.val = moment();

    if (valid('days')) {
      field('days').validations.val = moment.weekdays().map(w => ({
        text: w,
        active: moment().format('dddd') === w ? true : false
      }));
    }

    if (valid('hours')) field('hours').validations.val = [{
      startTime: '00:00',
      endTime: '00:00'
    }];
  }

  toggleDay = i => {
    const { field, onChange } = this.props;

    onChange(field('days'), [
        ...field('days').validations.val,
        ...(field('days').validations.val[i]['active'] = !field('days').validations.val[i][
          'active'
        ])
      ]);
  };

  toggleRepeat = () => {
    this.setState({ repeating: !this.state.repeating });

    if (!this.state.repeating) {
      this.handleEndChange(null);
    } else {
      this.handleEndChange(moment());
    }
  };

  toggleAllDay = () => {
    this.setState({ allDay: !this.state.allDay });
  };

  onChange = (index, value) => {
    this.props.field('hours').validations.val[index] = value;
  };

  render() {
    const {
      charLimit,
      counter,
      croppedImage,
      field,
      handleImage,
      onChange,
      removeImage,
      valid
    } = this.props;

    const body = field('body');

    this.setDefaultInputs();

    return (
      <div className="SpecialPost">
        <div className="mb-4 text-tomato">
          All fields required unless marked as optional
        </div>
        {/* <section className="mb-4">
          <h1 className="font-size-09 mb-2">FREQUENCY</h1>
          <button className="frequency-button btn-pill active px-3 py-1 mr-4">
            <i className="fa fa-retweet" aria-hidden="true" /> Repeating
          </button>
          <button className="frequency-button btn-pill px-3 py-1">
            <i className="fa fa-star-o" aria-hidden="true" /> One-Time
          </button>
        </section> */}
        <section className="mb-4">
          <h1 className="font-size-09 mb-2">DESCRIPTION</h1>
          <div
            className={classNames('textarea-counter mb-4', {
              'over-limit': counter(body, charLimit) < 0
            })}
          >
            <ReactTextAreaWrapper
              className="b-0"
              input={body}
              onChange={onChange}
              valid={valid}
              placeholder="Add a short, descriptive name"
            />
            <div className="count">{counter(body, charLimit)}</div>
          </div>
        </section>
        <section className="mb-4">
          <h1 className="font-size-09 mb-2">START DATE</h1>
          <div className="d-inline-block mr-4">
            <CustomDatePicker
              selected={field('start') && field('start').validations.val}
              onChange={this.handleStartChange}
            />
          </div>
          {/* <div className="d-inline-block">
            <CustomDatePicker
              onChange={this.handleEndChange}
              selected={this.state.endDate}
              placeholderText="Until Stopped"
              minDate={moment()}
              popperPlacement="auto"
              className={classNames(this.state.endDate && 'pr-4')}
            />
          </div>
          {this.state.endDate &&
            <div className="d-inline-flex align-items-center" style={{borderBottom: '1px solid #ccc'}}>
              <button className="btn-unstyle text-tomato" onClick={this.clearEndDate}>
                <i className="fa icon-lv-cancel" aria-hidden="true" />
                <span className="sr-only">Remove End Date</span>
              </button>
            </div>
          } */}
        </section>
        {/* <section className="mb-4">
          <h1 className="font-size-09">FREQUENCY</h1>
          <RadioButton
            active={this.state.repeatFrequency === 'Daily'}
            text="Daily"
            onClickFn={() => this.handleRepeatFrequencyClick('Daily')}
          />
          <RadioButton
            active={this.state.repeatFrequency === 'Weekly'}
            text="Weekly"
            onClickFn={() => this.handleRepeatFrequencyClick('Weekly')}
          />
          <RadioButton
            active={this.state.repeatFrequency === 'Monthly'}
            text="Monthly"
            onClickFn={() => this.handleRepeatFrequencyClick('Monthly')}
          />
        </section> */}

        <section className="mb-4">
          <button className="btn-unstyle" onClick={this.toggleRepeat}>
            <i
              className={classNames('fa mr-2', {
                'fa-square-o': !this.state.repeating,
                'fa-check-square': this.state.repeating
              })}
              aria-hidden="true"
            />
            Repeat
          </button>
        </section>
        {this.state.repeating && (
          <div>
            <section className="mb-4">
              <h1 className="font-size-09">ENDING DATE</h1>
              <div className="d-inline-block">
                <CustomDatePicker
                  onChange={this.handleEndChange}
                  selected={field('end') && field('end').validations.val}
                  placeholderText="Never"
                  minDate={moment()}
                  popperPlacement="auto"
                  className={classNames(field('end') && field('end').validations.val === '' && 'pr-4')}
                />
              </div>
              {field('end') && field('end').validations.val && (
                <div
                  className="d-inline-flex align-items-center"
                  style={{ borderBottom: '1px solid #ccc' }}
                >
                  <button
                    className="btn-unstyle text-tomato"
                    onClick={this.handleEndChange.bind(this, null)}
                  >
                    <i className="fa icon-lv-cancel" aria-hidden="true" />
                    <span className="sr-only">Remove End Date</span>
                  </button>
                </div>
              )}
            </section>
            <section className="mb-4">
              <h1 className="font-size-09">EVERY</h1>
              <small className="mb-2 d-block">
                Select the day(s) this special repeats
              </small>
              {field('days') && <div className="days-of-week">
                {field('days').validations.val.map((day, i) => (
                  <DayToggle
                    key={i}
                    active={day.active}
                    text={truncate(day.text, { length: 3, omission: '' })}
                    onClickFn={() => this.toggleDay(i)}
                  />
                ))}
              </div>}
            </section>
          </div>
        )}
        <section className="mb-4">
          <h1 className="font-size-09">TIME AVAILABLE</h1>
          <RadioButton
            active={this.state.allDay}
            text="All Day"
            onClickFn={this.toggleAllDay}
          />
          <RadioButton
            active={!this.state.allDay}
            text="Specific Time(s)"
            onClickFn={this.toggleAllDay}
          />
        </section>
        {!this.state.allDay && (
          <section className="mb-4 relative">
            <h1 className="font-size-09">SET TIME AVAILABLE</h1>

            {field('hours').validations.val.map((t, i) => <TimePicker
              key={i}
              onChange={this.onChange.bind(this, i)}
            />)}

            <button
              className="btn btn-unstyle add-times text-tomato"
              onClick={this.addTime}
            >
              + Add Times
            </button>
            {field('hours').validations.val.length > 1 && (
              <button
                onClick={this.removeTime}
                className="remove-time text-tomato btn-unstyle"
              >
                <i className="fa icon-lv-cancel" aria-hidden="true" />
                <span className="d-none d-sm-inline ml-1">Remove</span>
              </button>
            )}
          </section>
        )}
        <div className="image-container">
          {croppedImage && (
            <img className="img-fluid" src={croppedImage} alt="post" />
          )}
          <div className="d-flex justify-content-between my-2 align-items-center">
            <ReactFileReader base64={true} handleFiles={handleImage}>
              <div className="btn-pill d-inline-flex align-items-center image-select px-3 py-1">
                <i className="image-select-icon fa fa-camera mr-1" />
                <span>{croppedImage ? 'Replace' : 'Add'} Photo</span>
              </div>
            </ReactFileReader>
            {croppedImage && (
              <div className="pull-right text-danger" onClick={removeImage}>
                Remove Photo
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SpecialPost.defaultProps = {
  charLimit: 200
};

SpecialPost.propTypes = {
  charLimit: PropTypes.number,
  counter: PropTypes.func.isRequired,
  field: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  valid: PropTypes.func.isRequired,
  croppedImage: PropTypes.array,
  handleImage: PropTypes.func.isRequired,
  removeImage: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Social/SpecialPost.js